import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/ReporteEmbarqueSector12Linea5Actions'
import { ReporteEmbarqueSector12Linea5View } from '../components/ReporteEmbarqueSector12Linea5View'

class ReporteEmbarqueSector12Linea5 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable(this.props.cereal, this.props.cerealVariedad, this.props.etiqueta)
  }

  componentDidUpdate (prevProps) {
    if (this.props.cereal !== undefined && this.props.cerealVariedad !== undefined && this.props.etiqueta !== undefined &&
       (this.props.cereal !== prevProps.cereal || this.props.cerealVariedad !== prevProps.cerealVariedad || this.props.etiqueta !== prevProps.etiqueta)) {
      this.props.actualizarDatosParaMuiTable(this.props.cereal, this.props.cerealVariedad, this.props.etiqueta)
    }
  }

  render () {
    return <ReporteEmbarqueSector12Linea5View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const mapStateToProps = (state) => ({
  cereal: state.filtrosParaEmbarque.cereal,
  cerealVariedad: state.filtrosParaEmbarque.cerealVariedad,
  etiqueta: state.filtrosParaEmbarque.etiqueta
})

const withRedux = connect(mapStateToProps, mapActionsToProps)

export default withRedux(ReporteEmbarqueSector12Linea5)
